// 此文件由 json_to_games.py 自动生成
// 生成时间: 2025-03-26 18:37:30

export default {
  "id": "find-the-sprunki",
  "slug": "find-the-sprunki",
  "publisher": "GoGameVault",
  "thumbnail": "https://img.gamedistribution.com/92f180d64c4746e9bfa3322092b110b0-512x384.jpg",
  "gameUrl": "https://html5.gamedistribution.com/92f180d64c4746e9bfa3322092b110b0/",
  "releaseDate": "2025-03-26",
  "rating": 4.5,
  "plays": 0,
  "isNew": true,
  "isPopular": false,
  "isRecommended": false,
  "i18n": {
    "en": {
      "title": "Find the Sprunki",
      "description": "Find out the hidden Sprunki in the specified images. Each level has 12 hidden Sprunki. There are 12 levels in total. The time is limited so be fast and find all hidden objects before time runs out. Clicking in the wrong place several times reduces the time by an additional 5 seconds. So, if you are ready, start the game and have fun!",
      "instructions": "Use mouse or touch on the screen!",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1player",
        "challenge",
        "hidden"
      ]
    },
    "zh-CN": {
      "title": "找到Sprunki",
      "description": "找出指定图片中的隐藏Sprunki。每个关卡有12个隐藏的Sprunki。总共有12个关卡。时间有限，所以要快，在时间耗尽前找到所有隐藏物品。点击错误位置多次会额外减少5秒时间。如果你准备好了，就开始游戏吧，享受乐趣！",
      "instructions": "使用鼠标或触摸屏幕！",
      "genres": [
        "谜题"
      ],
      "tags": [
        "1玩家",
        "挑战",
        "隐藏"
      ]
    },
    "zh-TW": {
      "title": "尋找Sprunki",
      "description": "找出指定圖片中隱藏的 Sprunki。每關有 12 項隱藏的 Sprunki。總共有 12 關。時間有限，所以請快點，在時間用盡前找出所有隱藏的物品。點擊錯誤的位置多次會額外減少 5 秒鐘。如果你準備好了，開始遊戲並享受樂趣吧！",
      "instructions": "使用滑鼠或觸控螢幕！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1人",
        "挑戰",
        "隱藏"
      ]
    },
    "zh-HK": {
      "title": "尋找 Sprunki",
      "description": "找出指定圖片中隱藏的Sprunki。每關有12個隱藏的Sprunki。總共有12關。時間有限，所以要快，在時間耗盡前找出所有隱藏的物件。多次點擊錯誤的位置會減少5秒鐘的時間。所以，如果你準備好了，開始遊戲並享受樂趣吧！",
      "instructions": "使用滑鼠或觸控螢幕！",
      "genres": [
        "謎題"
      ],
      "tags": [
        "1玩家",
        "挑戰",
        "隱藏"
      ]
    },
    "ja": {
      "title": "スプリンキを探せ！",
      "description": "指定の画像の中の隠されたSprunkiを見つけなさい。各レベルには12個の隠されたSprunkiがあります。合計で12レベルあります。時間は限られているので、時間切れ前にすべての隠されたオブジェクトを見つけてください。間違った場所を何度もクリックすると、時間がさらに5秒減ります。那么，もし準備ができたら、ゲームを始めて楽しむんだね！",
      "instructions": "マウスまたはスクリーンにタッチしてください！",
      "genres": [
        "パズル"
      ],
      "tags": [
        "1プレイヤー",
        "挑戦",
        "隠された"
      ]
    },
    "ko": {
      "title": "스프런키 찾기",
      "description": "지정된 이미지에서 숨겨진 Sprunki를 찾아보세요. 각 레벨에는 12개의 숨겨진 Sprunki가 있습니다. 총 12레벨이 있습니다. 시간이 제한되어 있으니 빨리 모든 숨겨진 물체를 찾아야 합니다. 잘못된 곳을 여러 번 클릭하면 시간이 추가로 5초 줄어듭니다. 준비가 되었으면 게임을 시작하고 즐겨주세요!",
      "instructions": "마우스나 스크린에 터치하세요!",
      "genres": [
        "퍼즐"
      ],
      "tags": [
        "1플레이어",
        "도전",
        "숨겨진"
      ]
    },
    "fr": {
      "title": "Trouvez le Sprunki",
      "description": "Trouvez le Sprunki caché dans les images spécifiées. Chaque niveau comporte 12 Sprunki cachés. Il y a au total 12 niveaux. Le temps est limité, donc soyez rapide et trouvez tous les objets cachés avant que le temps ne s'épuise. Cliquez plusieurs fois à un mauvais endroit pour réduire le temps de 5 secondes supplémentaires. Alors, si vous êtes prêt, démarrez le jeu et amusez-vous !",
      "instructions": "Utilisez la souris ou le toucher sur l'écran !",
      "genres": [
        "Puzzle"
      ],
      "tags": [
        "1 joueur",
        "défi",
        "caché"
      ]
    }
  }
};
